export function accordionScripts(): void {

    let accordionItems = document.querySelectorAll("sl-details.accordion")
    accordionItems.forEach( item=>{
        item.addEventListener('sl-after-show', () => {
            item.classList.toggle("accordion-open")
            item.classList.toggle("accordion")
        });
        item.addEventListener('sl-after-hide', () => {
            item.classList.toggle("accordion-open",)
            item.classList.toggle("accordion")
        });
    })
   
}